module.exports = __webpack_public_path__ + "img/marketing_map_4.b8dcadf2.png";